import { Injectable } from '@angular/core';
import { Http, Headers , RequestOptions } from '@angular/http';

import { AuthServiceProvider } from '../auth-service/auth-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
/*
  Generated class for the EmpleadoServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EmpleadoServiceProvider {
	
  serverServicios = "";
  headers = new Headers();
  constructor(public http: Http, public autorizacionService: AuthServiceProvider) {
    //this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";

    this.headers.append('Authorization', this.autorizacionService.token);
  }

  getResults(keyword:string) {
    return this.http.get(this.serverServicios + '/posentidad/filtro/1/1/'+keyword, {headers: this.headers})
      .map(
        result =>
        {
          return result.json()
        });
  }
}



// WEBPACK FOOTER //
// ./src/providers/empleado-service/empleado-service.ts